export enum cacheSuffixes {
    customerData = '-customer-data',
    customerSummary = '-customer-summary-data',
    groupOptions = '-group-options',
    customerOptions = 'customer-options',
    currentCustomerId = 'current-customer-id'
}